<template>
   <v-container fluid class="d-flex justify-center align-center backgroundW"
      style="height: 100vh;position: fixed; top: 0;left:0; width:100vw ; z-index: 1000;">

      <div>
         <AnimatedLogo height="100px" classes="justify-center d-flex" />
         <v-progress-circular :size="40" :width="5" style="margin: auto; " class="d-block" color="primary"
            indeterminate></v-progress-circular>
      </div>

   </v-container>
</template>
<style  scoped>
</style>


<script>
import AnimatedLogo from './AnimatedLogo.vue';

export default {
   name: "SplashLoader",
   computed: {

   },
   components: { AnimatedLogo },
   data: () => ({

   }),
   mounted() {

   },

   methods: {

   },
};
</script>
